import { JewelryTypeName } from '../typings/jewelry-type'
import { BaseConfigDto } from '../dto/base-config.dto'
import { MaterialColorDto } from '../dto/material-color.dto'
import { DiamondCutDto } from '../dto/diamond-cut.dto'
import { ReflectionMapDto } from '../dto/reflection-map.dto'
import { PosteffectsConfigDto } from '../dto/posteffects-config.dto'
import { DiamondBandDto } from '../dto/diamond-band.dto'
import { StoneHaloDto } from '../dto/stone-halo.dto'
import { StoneSizeDto } from '../dto/stone-size.dto'

export abstract class BaseConfig {
  sku: string
  previewImageUrl?: string
  modelPath: string
  category: JewelryTypeName
  buyItNowEnabled: boolean
  linkToProduct: string
  reflectionMap?: ReflectionMapDto
  materialColors?: Array<MaterialColorDto>
  diamondCuts?: Array<DiamondCutDto>
  diamondBands?: Array<DiamondBandDto>
  stoneHalos?: Array<StoneHaloDto>
  stoneSizes?: Array<StoneSizeDto>
  posteffectsConfig?: PosteffectsConfigDto

  constructor(baseConfigDto: BaseConfigDto) {
    this.sku = baseConfigDto.sku
    this.previewImageUrl = baseConfigDto.previewImageUrl
    this.modelPath = baseConfigDto.modelPath
    this.category = baseConfigDto.category
    this.buyItNowEnabled = baseConfigDto.buyItNowEnabled
    this.linkToProduct = baseConfigDto.linkToProduct
    this.reflectionMap = baseConfigDto.reflectionMap
    this.materialColors = baseConfigDto.materialColors
    this.diamondCuts = baseConfigDto.diamondCuts
    this.diamondBands = baseConfigDto.diamondBands
    this.stoneSizes = baseConfigDto.stoneSizes
    this.stoneHalos = baseConfigDto.stoneHalos
    this.posteffectsConfig = baseConfigDto.posteffectsConfig
  }
}
